import React, { useState } from "react";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
import { Link } from "react-router-dom";
import { useParams } from "react-router";
import MediaSelector from "../../UploadComponents/MediaSelector";
import Card from "./Card";
import { object_url } from "../../../../../api/helper";
import { uploadMedia } from "../../../../../api/aws_s3";
import {
  isWithinSoundtrackSizeLimit,
  SOUNDTRACK_SIZE_LIMIT,
} from "../../../../shared/viewsHelper";
import { useSelector } from "react-redux";
import store from "../../../../../redux/store";
import actions from "../../../../../redux/actions";
import PrimoSubscriptionModal from "../../../shared/PrimoSubscriptionModal";
import { useLocation } from "react-router-dom";

function AlbumUploadTracks() {
  let { album_id }: any = useParams();
  const [subscribeModal, setSubscribeModal] = useState(false);
  const { hash } = useLocation();
  const { new_tracks, current_user } = useSelector(
    ({ new_tracks, current_user }: any) => ({
      new_tracks,
      current_user,
    })
  );

  const onUploadFile = async (event: any) => {
    try {
      const file = event.target.files[0];
      const s3_object_key = object_url();
      if (!file) {
        return;
      }
      if (!isWithinSoundtrackSizeLimit(file)) {
        alert(`Maximum file size is ${SOUNDTRACK_SIZE_LIMIT / 1024}MB`);
        return;
      }
      store.dispatch(
        actions.insertNewTrack({
          file,
          s3_object_key,
          progress: -1,
        })
      );

      await uploadMedia(
        file,
        file.type,
        current_user.id,
        s3_object_key,
        (e: any) =>
          store.dispatch(
            actions.updateNewTrack({
              file,
              s3_object_key,
              progress: (e.loaded * 100) / e.total,
            })
          )
      );
    } catch (error) {
      alert(error.message);
    }
  };

  const onMoveCard = (dragIndex: any, hoverIndex: any) => {
    store.dispatch(actions.shiftNewTrack(dragIndex, hoverIndex));
  };

  const handleDistributeClick = () => {
    if (current_user.is_subscribed_to_primo) {
      window.open(process.env.REACT_APP_EVEARA_BASE_URL);
    } else {
      setSubscribeModal(true);
    }
  };

  const onRemoveTrack = (track: any) =>
    window.confirm("Are you sure you wish to delete this item?") &&
    store.dispatch(actions.removeNewTrack(track));

  const noteStyle = {
    textAlign: 'justify', 
    marginTop: -14,
    fontSize: 14
  }

  return (
    <React.Fragment>
      <DndProvider backend={HTML5Backend}>
        <div className="tracks-upload m-5">
          <h1>Upload Track to Album </h1>
          <p style={{marginTop: 10}}><b>Accepted Formats:</b> .mp3, .m4a*, .wav, .flac, .ogg or .aiff*</p><br/>
          <p style={noteStyle}><b>*Please note:</b> m4a and aiff formats are accepted for use in music distribution purposes <b>only</b> (via UNIFI Music's <a href='javascript:void(0)' onClick={handleDistributeClick}>PRIMO plan</a>), but will not play on any on-site players, or our embeddable music player due to compatibility issues with browser-based audio players.
          </p>
          <div className="d-flex flex-column justify-content-between align-items-center py-3">
            {new_tracks.map((new_track: any, index: any) => (
              <Card
                className={new_tracks.length <= 1 && "hide-drag-style"}
                key={new_track.s3_object_key}
                new_track={new_track}
                index={index}
                totalTracks={new_tracks.length}
                onMoveCard={onMoveCard}
                onRemoveTrack={onRemoveTrack}
              />
            ))}
            {new_tracks.length > 1 && (
              <div className="d-flex mt-3 align-items-center rearrange-hint w-100">
                <p>Drag or click arrows to "rearrange" the order.</p>
              </div>
            )}

            <MediaSelector
              onChange={onUploadFile}
              className={new_tracks.length > 0 ? "mt-4" : ""}
              name="track"
              label={
                new_tracks.length
                  ? "UPLOAD ANOTHER TRACK"
                  : "CHOOSE TRACK TO UPLOAD"
              }
            />
            <Link
              to={
                new_tracks.length > 0
                  ? `/upload/albums/${album_id}/edit_tracks`
                  : ""
              }
              className={`btn btn-primary btn-md mt-3 ${
                new_tracks.length > 0 ? "" : "disabled"
              }`}
            >
              Next
            </Link>
          </div>
        </div>
      </DndProvider>
      {(subscribeModal || ["#primo", "#primo-info"].includes(hash)) && (
      <PrimoSubscriptionModal
        showModal={subscribeModal}
        setSubscribeModal={setSubscribeModal}
        hash={["#primo", "#primo-info"].includes(hash)}
        showDistributingInfo={hash === "#primo-info"}
      />
    )}
    </React.Fragment>

  );
}

export default React.memo(AlbumUploadTracks);
